import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar, Footer } from './components';
import {
  CarServicePage,
  RentalServicePage,
  AboutPage
} from './pages';
import type { NavItem } from './types';

/**
 * 主应用组件
 * 按照需求文档实现7个核心页面的路由结构
 */
function App() {
  // 导航菜单配置 - 保留关于我们、车后服务、租车服务、服务平台
  const navItems: NavItem[] = [
    {
      label: '关于我们',
      href: '/about',
    },
    {
      label: '车后服务',
      href: '/car-service',
      isCoreService: true,
    },
    {
      label: '车务服务',
      href: '/rental-service',
      isCoreService: true,
    },
    {
      label: '服务平台',
      href: '#',
      children: [
        {
          label: '能源服务平台',
          href: 'https://store.cheweijia.com/login',
        },
        {
          label: '门店服务平台',
          href: 'https://partner.cheweijia.com/login',
        },
        {
          label: '租车服务平台',
          href: 'https://che.cheweijia.com/',
        },
      ],
    },
  ];
  
  // 页脚链接配置
  const footerSections = [
    {
      title: '车后服务',
      links: [
        { label: '充电服务', href: '/car-service#charging' },
        { label: '加油服务', href: '/car-service#refueling' },
        { label: '维修保养', href: '/car-service#maintenance' },
        { label: '便利店零售', href: '/car-service#retail' },
      ],
    },
    {
      title: '车务服务',
      links: [
        { label: '车务服务', href: '/rental-service' },
      ],
    },
    {
      title: '后台入口',
      links: [
        { label: '能源服务平台', href: 'https://store.cheweijia.com/login' },
        { label: '门店服务平台', href: 'https://partner.cheweijia.com/login' },
        { label: '租车服务平台', href: 'https://che.cheweijia.com/' },
      ],
    },
    {
      title: '公司信息',
      links: [
        { label: '关于我们', href: '/about' },
        { label: '联系方式', href: '/about#contact' },
      ],
    },
  ];
  
  return (
    <Router>
      <div className="min-h-screen bg-white">
        {/* 导航栏 */}
        <Navbar navItems={navItems} />
        
        {/* 主要内容 - 路由配置 */}
        <main>
          <Routes>
            <Route path="/" element={<AboutPage />} />
            <Route path="/car-service" element={<CarServicePage />} />
            <Route path="/rental-service" element={<RentalServicePage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </main>
        
        {/* 页脚 */}
        <Footer
          sections={footerSections}
          contactInfo={{
            phone: '+86 400-123-4567',
            email: 'kefu@hard-inc.com',
            address: '北京市朝阳区望京国际研发园H座1层',
          }}
        />
      </div>
    </Router>
  );
}

export default App;
